module.exports = __webpack_public_path__ + "static/media/kw.841518c8.svg";